// Configuration for API throttle/debounce behavior
// Define endpoints (substrings) that should be excluded from throttling (treated as "debounced" from a throttle perspective)
// Use substrings to match endpoints; adjust as needed for your API surface.
export const debounceExclusions = [
  '/search',
  '/alarmHistory',
  '/Alarms/Search',
  '/alarms/search',
  '/AlarmHistory',
  // Paginated alarms and pending alarms endpoints - allow rapid searches
  '/getPendingAlarms',
  '/getPendingAlarmsPaginated',
  '/getAlarmHistoryPaginated',

  // Widget permission list - can be called frequently during dashboard edits
  '/getGlobalWidgetPermList',
  '/getJurisdictions',
  '/getAllActiveAlerts',
  `/getFusionPlaces`,
  '/getAuditLogs',
  '/getGlobalActionsByWPId',
  '/validateRoutePerms',
  '/getDeviceGroups_v2',

  //Custome Weather
  '/getAstronomyData',
  '/customWeatherExt15',
  '/getCurConditionsbyCity',
  '/customWeatherCurHourlyForecast',
  '/getDetailedForecastData',

  // causes widget issues when throttled
  '/getWidgets',
  '/getFusionRoleById',
];

// ============================================================================
// BYPASS SECTION - NO THROTTLE OR DEBOUNCE
// ============================================================================
// These endpoints bypass ALL rate limiting (throttle AND debounce).
// Use sparingly - only for cases where a proper fix would take too long.
// TODO: Review and fix these properly when time allows, or document why
// they must remain bypassed permanently.
// ============================================================================
export const bypassExclusions = [
  // Add endpoints here that need to completely bypass throttle/debounce
  // Example: '/someEndpoint',
  '/getAirportConditionsbyState',
  '/getFusionRoles',
  `/getAllFusionMembers`,
  `/getFusionRoleById`,
  '/getSystemTypeMap_v2',
  '/getConnectedDevices_v2',
  '/getSystemIntegrations_v2',
  '/getAuditLogs',
  '/getFusionUserProfile',
  '/getDetailedMarine7',
  '/informLocationChange',
  '/getAirQualityForecast',
  '/getAirQualityObservation',
  '/getfusionUserPerms',
  '/getAccessLevel',
  '/getDeviceTypeMap_v2',
];

export function isUrlBypassed(url) {
  if (!url) return false;
  const u = String(url);
  return bypassExclusions.some((pat) => u.includes(pat));
}

export function isUrlExcludedFromThrottle(url) {
  if (!url) return false;
  const u = String(url);
  return debounceExclusions.some((pat) => u.includes(pat));
}
